<template>
  <div id="app">
      <div class="app-view">

         <router-view>

            {{ /* Blocking alerts */ }}
            <div v-if="error">
               <h1>Oops!</h1>
               <div class="alert alert-danger">
                  <i class="fas fa-exclamation-triangle"></i>
                  {{ error.message }}
               </div>

               <div v-if="!attempts_are_blocked">
                  <button class="error-btn btn btn-primary" v-if="window_has_history" @click="go_back">
                     <i class="fas fa-arrow-alt-circle-left"></i>
                     Go back
                  </button>

                  <button class="error-btn btn btn-primary" @click="clear_show">
                     Verify now
                  </button>
               </div>

               </div>

            <div v-if="wait">
               <div class="alert alert-primary">{{ wait.message }}</div>
               <div class="progress">
               <div class="progress-bar progress-bar-striped progress-bar-animated bg-info" role="progressbar" :aria-valuenow="wait.percent" aria-valuemin="0" aria-valuemax="100" :style="`width: ${wait.percent}%`"></div>
               </div>
            </div>

         </router-view>
      </div>
  </div>
</template>

<script>
// import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';

export default {
   components: {
   },

   computed:{
      error (){
         return this.$store.state.error;
      },

      problem (){
         return this.$store.state.problem;
      },

      wait (){
         return this.$store.state.wait;
      },

      meeting_info (){
         return this.$store.state.meeting_info;
      },// /meeting_info()

      attempts_are_blocked(){
         return this.$store.state.attempts >= this.$store.state.max_attempts
      },

      window_has_history (){
         return window.history.length > 1;
      },


      ...mapGetters([
         'page_title',
         'no_blocking_alerts',
         'no_blocking_errors'
      ])
   },// /computed()

   methods:{
      go_back(){
         window.history.back();
      }
   },

   mounted (){

   }// /mounted()
};
</script>


<style lang="scss">

#app
{
   background-color: #2f323a;
   height: 100vh;
}

.app-view
{
   max-width: 50em;
   margin: auto;
   padding-top: 3em;
}
.app-header
{
   margin-bottom: 1em;
}
.campaign-info
{
   margin-bottom: 1em;
}

h2.app-view-title
{
   border-bottom: 1px solid #999999;
   padding-bottom: 0.3em;
   margin-bottom: 1em;
}

.error-btn
{
   width: 100%;
   margin-bottom: 1em;
}
</style>
